import React, { Component } from 'react';
import { routeActions } from 'redux-simple-router';
import { connect } from 'react-redux';
import {
  attemptGetActivities,
  onActivityDrop,
  registerHours,
  setEmployeeIsDragging,
  setEmployeeHours,
  attemptSaveRegistration,
  getEmployeeSuggestions,
  attemptAddEmployee,
  setDroppedEmployee,
  attemptSaveConflictedEmployees,
  setEmployeeAbsence,
  setActivityIsDragging,
  changeRegistrationDate,
  attemptResetEmployees,
  rmEmployeeFromProject,
  attemptMoveEmployee
} from './actions'
import { httpGet, httpPut, httpPost } from '../../Util/http';
import ColumnComponent from './columnComponent';
import PageSpinner from '../../Common/pageSpinner';
import Sidebar from './Sidebar';
import Chat from './chat';
import SlideInBar from './slideInBar'
import ConflictWizard from './ConflictWizard';
import '../../../Content/css/sidebarSlideAnimation.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Radium from 'radium';
import Waves from 'node-waves'
import ConfirmationModal from '../../Common/confirmationModal'

import auth from '../../Login/authService'

class ActivityOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSidebar: false,
      confirmationModalIsOpen: false
    }
  }
  componentWillMount = () => {
    this.props.dispatch(attemptGetActivities(this.props.params.projectNumber))
  };
  componentWillReceiveProps = (nextProps) => {
    //if it has just saved conflicted, dont show sidebar
    if (this.props.isSavingConflicted && !nextProps.isSavingConflicted)
      this.setState({
        showSidebar: false
      })
    //if it has just saved registration and there is no confliced, dont show sidebar
    if (this.props.isSavingRegistration && !nextProps.isSavingRegistration && !this.props.employeesWithConflict.length)
      this.setState({
        showSidebar: false
      })
  };
  toggleRegisterHours = () => {
    if (this.state.showSidebar)
      this.props.dispatch(attemptGetActivities(this.props.params.projectNumber, true))
    this.setState({
      showSidebar: !this.state.showSidebar
    });
  };
  displayModal = () => {
    this.setState({
      confirmationModalIsOpen: true
    })
  };
  closeModal = () => {
    this.setState({
      confirmationModalIsOpen: false
    })
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
  };

  render() {
    const {
      toDoActivities, standByActivities, doingActivities, doneActivities,
      dispatch, activityOrganizer, project, params, isLoading,
      routine, employees, draggingEmployee, isResetLoading, employeeSuggestions,
      employeesWithConflict, activities, isSavingConflicted, activityIsDragging,
      registrationDate, isSavingRegistration, employeesIsFetching } = this.props;

    const userRole = auth.getProfile().role;
    const { showSidebar } = this.state;
    const redirectTo = (url) => dispatch(routeActions.push(url))
    const onActivityDropFunc = (activityId, columnId, index, oldColumnId, oldIndex) => dispatch(onActivityDrop(activityId, columnId, index, oldColumnId, oldIndex, activityOrganizer, project.id));
    const registerHoursFunc = (employeeIndex, registeredHours, activityId, employeeId, isNight) => dispatch(registerHours(employeeIndex, registeredHours, activityId, employeeId, isNight))
    const sidebar = this.state.showSidebar ?
      <Sidebar
        onClose={this.toggleRegisterHours}
        routine={routine}
        employees={employees}
        setEmployeeIsDragging={(employeeIndex) => dispatch(setEmployeeIsDragging(employeeIndex))}
        setEmployeeHours={(employeeIndex, hours, isNighthours) => dispatch(setEmployeeHours(employeeIndex, hours, isNighthours))}
        isResetLoading={isResetLoading}
        attemptSaveRegistration={() => dispatch(attemptSaveRegistration())}
        getEmployeeSuggestions={(val) => dispatch(getEmployeeSuggestions(val))}
        employeeSuggestions={employeeSuggestions}
        addEmployee={(val) => dispatch(attemptAddEmployee(val))}
        setDroppedEmployee={(activityId, employeeId) => dispatch(setDroppedEmployee(activityId, employeeId))}
        setEmployeeAbsence={(employeeIndex, activities, employeeId) => dispatch(setEmployeeAbsence(employeeIndex, routine, activities, employeeId))}
        registrationDate={registrationDate}
        changeRegistrationDate={(date) => dispatch(changeRegistrationDate(date))}
        isSavingRegistration={isSavingRegistration}
        attemptResetEmployees={this.displayModal}
        employeesIsFetching={employeesIsFetching}
        draggingEmployee={draggingEmployee}
        rmEmployeeFromProject={(employeeIndex, employeeId) => dispatch(rmEmployeeFromProject(employeeIndex, employeeId))}
        moveEmployee={(employeeIndex, newIndex) => dispatch(attemptMoveEmployee(employeeIndex, newIndex))}
      /> : null;
    return (
      isLoading ?
        <PageSpinner />
        :
        <div>
          {this.state.confirmationModalIsOpen ?
            <ConfirmationModal
              closeModal={this.closeModal}
              onYesMethod={() => dispatch(attemptResetEmployees())}
              headerText="Nulstilling"
              text={<div>Du er ved at nulstille timeregistreringen. <br />
                Vil du fortsætte ?
              </div>}
            /> : null}

          {employeesWithConflict.length ?
            <ConflictWizard
              activities={activities}
              employeesWithConflict={employeesWithConflict}
              attemptSaveConflictedEmployees={(val) => dispatch(attemptSaveConflictedEmployees(val))}
              isSavingConflicted={isSavingConflicted}
              registrationDate={registrationDate}
            /> : null}

          {/*this.props.children is RegisterActivities rendered by Router
http://stackoverflow.com/questions/27612765/nested-routes-in-react-router*/}
          {this.props.children}
          <div style={styles.container}>
            <div className="row" style={styles.upperContainer}>
              {userRole === "Funktionær" || userRole === "Insights" ?
                <div>
                  <div className="col-sm-3 col-sm-offset-6 text-center">
                    <button
                      className="btn btn-primary waves-btn"
                      onClick={() => {
                        const departmentId = "00000000-0000-0000-0000-000000000000";
                        const projectId = this.props.project.id;
                        const clientId = this.props.project.client;

                        httpGet(process.env.REACT_APP_webApiEndPoint + 'api/workplace/' + projectId)
                          .then(result => result.json)
                          .then(() => {
                            window.localStorage.setItem("wp", project.number);
                            window.location.assign(window.location.origin + "/afdeling/00000000-0000-0000-0000-000000000000/arbejdssted/"+projectId+"/oversigt")
                          })
                          .catch(() => {
                            var _url = process.env.REACT_APP_webApiEndPoint + 'api/client/contact';
                            return httpPost(_url, {
                              ClientId: clientId,
                              contactName: project.name
                            }).then(result => result.json())
                              .then(contact => {
                                console.log(contact)
                                var _ur2l = process.env.REACT_APP_webApiEndPoint + 'api/workplace';
                                httpPost(_ur2l, {
                                  name: project.name,
                                  contactId: contact,
                                  projectId,
                                  departmentId,
                                  workplaceId: project.id
                                }).then(result => result.json())
                                  .then((workplace) => {
                                    window.location.assign(window.location.origin + "/afdeling/00000000-0000-0000-0000-000000000000/arbejdssted/"+projectId+"/oversigt")
                                  })
                              })
                          })

                      }}
                      style={styles.timeRegistrationBtn}>
                      APV | Dagrapport
                    </button>
                    <button
                      className="btn btn-primary waves-btn"
                      onClick={() => this.setState({ showChat: true })}
                      style={[styles.timeRegistrationBtn, styles.floatRight]}>
                      Beskeder
                    </button>
                  </div>

                  <div className="col-sm-3 text-center">
                    <button
                      className="btn btn-primary waves-btn"
                      onClick={() => dispatch(routeActions.push("/tilbud/sag/" + params.projectNumber + "/ugeoversigt"))}
                      style={styles.timeRegistrationBtn}>
                      Projektoversigt
                    </button>
                    <button
                      className="btn btn-primary  waves-btn"
                      onClick={this.toggleRegisterHours}
                      style={[styles.timeRegistrationBtn, styles.floatRight]}>
                      Timeregistrering
                    </button>
                  </div>
                </div>
                :
                null}
              {userRole === "Formand" ?
                <div className="col-sm-3 col-sm-offset-9 text-center">
                  <button
                    className="btn btn-primary waves-btn"
                    onClick={() => this.setState({ showChat: true })}
                    style={[styles.timeRegistrationBtn]}>
                    Beskeder
                  </button>
                  <button
                    className="btn btn-primary waves-btn"
                    onClick={this.toggleRegisterHours}
                    style={[styles.timeRegistrationBtn, styles.floatRight]}>
                    Timeregistrering
                  </button>
                </div> : null
              }
            </div>
            <div className="row" style={styles.columnContainer}>
              {this.state.showSidebar ?
                /*when sidebar is open concat the two first columns to one*/
                <div className="col-sm-3" style={styles.column}>
                  <div style={styles.standBySplit}>
                    <ColumnComponent
                      registrationDate={registrationDate}
                      title="STAND BY"
                      columnNumber={1}
                      onActivityDrop={onActivityDropFunc}
                      activities={standByActivities}
                      params={this.props.params}
                      userRole={userRole}
                      showSidebar={showSidebar}
                      registerHours={registerHoursFunc}
                      draggingEmployee={draggingEmployee}
                      setEmployeeHours={(employeeIndex, hours, isNighthours) => dispatch(setEmployeeHours(employeeIndex, hours, isNighthours))}
                      redirectTo={redirectTo}
                      setActivityIsDragging={(bool) => dispatch(setActivityIsDragging(bool))}
                      activityIsDragging={activityIsDragging}
                    />
                  </div>
                  <div style={styles.toDoSplit}>
                    <ColumnComponent
                      title="TODO"
                      registrationDate={registrationDate}
                      columnNumber={0}
                      onActivityDrop={onActivityDropFunc}
                      activities={toDoActivities}
                      params={this.props.params}
                      userRole={userRole}
                      showSidebar={showSidebar}
                      registerHours={registerHoursFunc}
                      draggingEmployee={draggingEmployee}
                      setEmployeeHours={(employeeIndex, hours, isNighthours) => dispatch(setEmployeeHours(employeeIndex, hours, isNighthours))}
                      redirectTo={redirectTo}
                      setActivityIsDragging={(bool) => dispatch(setActivityIsDragging(bool))}
                      activityIsDragging={activityIsDragging}
                    />
                  </div>
                </div>
                :
                /*when sidebar is closed show all rows normally*/
                <div className="col-sm-6" style={styles.twoFirstColumnContainer}>
                  <div className="col-sm-6" style={styles.column}>
                    <ColumnComponent
                      registrationDate={registrationDate}
                      title="TODO"
                      columnNumber={0}
                      onActivityDrop={onActivityDropFunc}
                      activities={toDoActivities}
                      params={this.props.params}
                      userRole={userRole}
                      showSidebar={showSidebar}
                      registerHours={registerHoursFunc}
                      draggingEmployee={draggingEmployee}
                      setEmployeeHours={(employeeIndex, hours, isNighthours) => dispatch(setEmployeeHours(employeeIndex, hours, isNighthours))}
                      redirectTo={redirectTo}
                      setActivityIsDragging={(bool) => dispatch(setActivityIsDragging(bool))}
                      activityIsDragging={activityIsDragging}
                    />
                  </div>
                  <div className="col-sm-6" style={styles.column}>
                    <ColumnComponent
                      registrationDate={registrationDate}
                      title="STAND BY"
                      columnNumber={1}
                      onActivityDrop={onActivityDropFunc}
                      activities={standByActivities}
                      params={this.props.params}
                      userRole={userRole}
                      showSidebar={showSidebar}
                      registerHours={registerHoursFunc}
                      draggingEmployee={draggingEmployee}
                      setEmployeeHours={(employeeIndex, hours, isNighthours) => dispatch(setEmployeeHours(employeeIndex, hours, isNighthours))}
                      redirectTo={redirectTo}
                      setActivityIsDragging={(bool) => dispatch(setActivityIsDragging(bool))}
                      activityIsDragging={activityIsDragging}
                    />
                  </div>
                </div>
              }
              <div className="col-sm-3" style={styles.column}>
                <ColumnComponent
                  registrationDate={registrationDate}
                  title="DOING"
                  columnNumber={2}
                  onActivityDrop={onActivityDropFunc}
                  activities={doingActivities}
                  params={this.props.params}
                  userRole={userRole}
                  showSidebar={showSidebar}
                  registerHours={registerHoursFunc}
                  draggingEmployee={draggingEmployee}
                  setEmployeeHours={(employeeIndex, hours, isNighthours) => dispatch(setEmployeeHours(employeeIndex, hours, isNighthours))}
                  redirectTo={redirectTo}
                  setActivityIsDragging={(bool) => dispatch(setActivityIsDragging(bool))}
                  activityIsDragging={activityIsDragging}
                />
              </div>
              <div className="col-sm-3" style={styles.column}>
                <ColumnComponent
                  registrationDate={registrationDate}
                  title="DONE"
                  columnNumber={3}
                  onActivityDrop={onActivityDropFunc}
                  activities={doneActivities}
                  params={this.props.params}
                  userRole={userRole}
                  showSidebar={showSidebar}
                  registerHours={registerHoursFunc}
                  draggingEmployee={draggingEmployee}
                  setEmployeeHours={(employeeIndex, hours, isNighthours) => dispatch(setEmployeeHours(employeeIndex, hours, isNighthours))}
                  redirectTo={redirectTo}
                  setActivityIsDragging={(bool) => dispatch(setActivityIsDragging(bool))}
                  activityIsDragging={activityIsDragging}
                />
              </div>
            </div>
            <ReactCSSTransitionGroup transitionName="slide" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
              {sidebar}
            </ReactCSSTransitionGroup>
            <ReactCSSTransitionGroup transitionName="slide" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
              {this.state.showChat ?
                <SlideInBar
                  onClose={() => this.setState({ showChat: false })}
                  style={{ width: '40%' }}
                  title={'Beskeder'}

                >
                  <Chat
                    show={(node) => {
                      window.open(node.document.fileUrl, '_blank');
                    }}
                    activityId={project.id}
                  />
                </SlideInBar>
                : null}
            </ReactCSSTransitionGroup>
          </div>
        </div>
    );
  }
}

var styles = {
  floatRight: {
    float: 'right'
  },
  timeRegistrationBtn: {
    borderRadius: '2px',
    padding: '0px',
    width: '113px',
    marginTop: '8px',
    float: 'left',
    textAlign: 'center',
    zIndex: '0',
    '@media (min-width: 1200px)': {
      width: '130px'
    }
  },
  container: {
    position: 'absolute',
    top: '0',
    left: '0',
    padding: '100px 12px 0 12px',
    width: '100%',
    height: '100%',
    marginRight: 'auto',
    marginLeft: 'auto',
    '@media (min-width: 1200px)': {
      maxWidth: '1170px',
      left: '50%',
      marginLeft: '-585px'
    }
  },
  upperContainer: {
    position: 'absolute',
    top: '50px',
    width: '100%'
  },
  h1: {
    fontWeight: 'bold',
    position: 'relative',
    top: '45px'
  },
  columnContainer: {
    position: 'relative',
    padding: '0 0 12px 0',
    height: '100%'
  },
  column: {
    height: '100%'
  },
  standBySplit: {
    height: '60%',
    paddingBottom: '12px'
  },
  toDoSplit: {
    height: '40%'
  },
  twoFirstColumnContainer: {
    float: 'left',
    height: '100%',
    padding: '0'
  }
}

function selectActivities(activityOverviewReducer, columnId) {
  if (activityOverviewReducer.activityOrganizer[columnId]) {
    return activityOverviewReducer.activityOrganizer[columnId].items.map((activityId, currentIndex) => {
      var unread = false;
      activityOverviewReducer.unread.forEach(function (id) {
        if (id === activityId) {
          unread = true;
        }
      });
      if (!activityOverviewReducer.activities[activityId]) {
        return null
      }
      return { ...activityOverviewReducer.activities[activityId], currentIndex: currentIndex, unread: unread }
    })
  }
  return [];
}

function selectProps(state) {
  return {
    activities: state.activityOverviewReducer.activities,
    toDoActivities: selectActivities(state.activityOverviewReducer, 0),
    standByActivities: selectActivities(state.activityOverviewReducer, 1),
    doingActivities: selectActivities(state.activityOverviewReducer, 2),
    doneActivities: selectActivities(state.activityOverviewReducer, 3),
    activityOrganizer: state.activityOverviewReducer.activityOrganizer,
    project: state.activityOverviewReducer.project,
    isLoading: state.activityOverviewReducer.isLoading,
    routine: state.activityOverviewReducer.routine,
    employees: state.activityOverviewReducer.employees,
    draggingEmployee: state.activityOverviewReducer.draggingEmployee,
    isResetLoading: state.activityOverviewReducer.isResetLoading,
    employeeSuggestions: state.activityOverviewReducer.employeeSuggestions,
    employeesWithConflict: state.activityOverviewReducer.employeesWithConflict,
    isSavingConflicted: state.activityOverviewReducer.isSavingConflicted,
    activityIsDragging: state.activityOverviewReducer.activityIsDragging,
    registrationDate: state.activityOverviewReducer.registrationDate,
    isSavingRegistration: state.activityOverviewReducer.isSavingRegistration,
    employeesIsFetching: state.activityOverviewReducer.employeesIsFetching
  };
}

export default connect(selectProps)(Radium(ActivityOverview));


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/index.jsx